module.exports = __webpack_public_path__ + "img/Uruguay.a3edc19b.svg";